import { css } from 'styled-components';
import { GridInputProps } from 'theme/_mixins/entities/props';
import { _grid } from 'theme/_mixins/mixins';

export const _gridInput = (props?: GridInputProps) => css`
  ${_grid({ columns: props?.columns, gap: props?.gap })};
  margin: ${props?.margin?.top || 0}px ${props?.margin?.right || 0}px ${props?.margin?.bottom || 0}px
    ${props?.margin?.left || 0}px;
`;
